import React, { useEffect } from 'react';
import { useTranslation }   from 'react-i18next';
import ReactPlayer          from 'react-player';

import ConsultationBlock   from '../../../components/consultationBlock';
import Meta                from '../../../components/meta';
import Preloader           from '../../../components/containers/preloader';
import HomePageSlider      from '../../../components/sliders/HomePageSlider';
import { useSiteSettings } from '../../../providers/siteSettings';
import { useUser }         from '../../../providers/user';

import { Category } from './category';

const HomePage = () => {
  const { t } = useTranslation();
  const {
          data: {
                  FRONT_PAGE_SEO,
                },
        }     = useSiteSettings();

  const {
          loading: uLoading,
          appealLoading,
          appealWait,
        } = useUser();

  const heroImage      = FRONT_PAGE_SEO?.images?.[0];
  const metaImages     = heroImage?.imgLink
    ? [{
      alt:  heroImage.alt || '',
      src:  `${heroImage.imgLink}.webp`,
      type: 'image/webp',
    }]
    : undefined;

  useEffect(() => {
    if (!isSSR()) {
      scrollTo({
        top:  0,
        left: 0,
      });
    }
  }, []);

  return (
    <>
      <div className={'page-content front'}>
        <Meta
          description={FRONT_PAGE_SEO?.frontPageDescription || t('default_meta_description')}
          images={metaImages}
          keywords={t('default_meta_keywords')}
          title={FRONT_PAGE_SEO?.frontPageTitle || t('default_meta_title')}
        />
        {!!FRONT_PAGE_SEO?.images?.length && <HomePageSlider images={FRONT_PAGE_SEO.images} />}
        {FRONT_PAGE_SEO?.video && (
          <ReactPlayer
            className={'video'}
            controls={true}
            playing={FRONT_PAGE_SEO.autoplay}
            muted={true}
            youtube={
              {
                playerVars: {
                  autoplay: FRONT_PAGE_SEO.autoplay ? 1 : 0,
                  muted:    0,
                },
              }
            }
            url={FRONT_PAGE_SEO.video.replace('/shorts/', '/embed/')}
          />
        )}
        <Category />
        <ConsultationBlock isDark />
      </div>
      {(uLoading || appealLoading || appealWait) && <Preloader />}
    </>
  );
};
export default HomePage;
